import { render, staticRenderFns } from "./BrandBannerSetting.vue?vue&type=template&id=3b8cbc54&scoped=true"
import script from "./BrandBannerSetting.vue?vue&type=script&lang=js"
export * from "./BrandBannerSetting.vue?vue&type=script&lang=js"
import style0 from "./BrandBannerSetting.vue?vue&type=style&index=0&id=3b8cbc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8cbc54",
  null
  
)

export default component.exports